import React from "react";
import { Link } from "react-router-dom";
import { urlFor } from "../../lib/sanityClient";

const categoryStyles = {
  "Product Update": "bg-primary/10 text-primary",
  "Finance Tips": "bg-green/10 text-green",
  "Company News": "bg-pink/10 text-pink",
};

const formatDate = (dateString) => {
  if (!dateString) return "";
  return new Date(dateString).toLocaleDateString("en-NG", {
    day: "numeric",
    month: "short",
    year: "numeric",
  });
};

export const NewsCard = ({ title, slug, category, excerpt, coverImage, publishedAt, readTime }) => {
  const pillStyle = categoryStyles[category] || "bg-grey-100 text-grey-700";

  return (
    <Link
      to={`/blog/${slug?.current}`}
      className="soft-shrink group flex flex-col rounded-[32px] overflow-hidden border border-grey-200 bg-white hover:shadow-lg transition-shadow duration-300"
    >
      {/* Cover image */}
      <div className="w-full aspect-[16/9] overflow-hidden bg-grey-100">
        {coverImage ? (
          <img
            src={urlFor(coverImage).width(640).height(360).fit("crop").url()}
            alt={title}
            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
          />
        ) : (
          <div className="w-full h-full bg-gradient-to-br from-primary/10 to-primary/5" />
        )}
      </div>

      {/* Content */}
      <div className="flex flex-col flex-1 gap-3 p-6">
        {/* Category pill */}
        {category && (
          <span className={`w-fit text-xs font-semibold px-3 py-1 rounded-full ${pillStyle}`}>
            {category}
          </span>
        )}

        {/* Title */}
        <p className="text-deep-primary font-medium text-xl leading-[28px] line-clamp-2">
          {title}
        </p>

        {/* Excerpt */}
        {excerpt && (
          <p className="text-grey-600 text-sm leading-[22px] line-clamp-3 flex-1">
            {excerpt}
          </p>
        )}

        {/* Footer: date + read time + arrow */}
        <div className="flex items-center justify-between mt-2 pt-4 border-t border-grey-100">
          <div className="flex items-center gap-2 text-grey-500 text-xs">
            {publishedAt && <span>{formatDate(publishedAt)}</span>}
            {publishedAt && readTime && <span>·</span>}
            {readTime && <span>{readTime} min read</span>}
          </div>
          <span className="text-primary text-sm font-semibold group-hover:translate-x-1 transition-transform duration-200">
            Read more →
          </span>
        </div>
      </div>
    </Link>
  );
};
